// Change this
const module = 'promo-codes'

import {checkAuth} from "@/services/auth";

// Change this
import Index from '@/views/promo-codes/Index'
import Create from '@/views/promo-codes/Create'
import Edit from '@/views/promo-codes/Edit'

var prefix = '/'

export default [
    {
        path: prefix+`${module}/`,
        name: `${module}Index`,
        component: Index,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/create`,
        name: `${module}Create`,
        component: Create,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/edit/:id`,
        name: `${module}Edit`,
        component: Edit,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
]
